/*
 * @Author: JulyL
 * @Date: 2020-03-29 14:47:36
 * @Description: 根据业务封装Ajax
 */
import Ajax from '../utils/Ajax';
import lang from '@/i18n/locale.js';
import messagebox from '@c/messagebox.js';
import { Message } from 'element-ui';

// 3秒之内的相同的get请求进行缓存
let cacheMillSeconds = 3 * 1000;
let cache = {};
let _get = Ajax.get;
Ajax.get = function () {
  let args = [].slice.call(arguments, 0);
  let key = JSON.stringify(args);
  let item = cache[key];
  let now = +new Date();
  if (item && now - item.date < cacheMillSeconds) {
    // console.log('use cache', key);
    return item.data;
  } else {
    cache[key] = {
      data: _get.apply(Ajax, args),
      date: now
    };
    return cache[key].data;
  }
};

let canShowError = true;
const handler1 = (pro, opt = {}) => {
  return pro
    .then((res) => {
      // 不进行任何处理
      if (opt.noHandler) {
        return res;
      }
      if (res.code == 0) {
        return res.data;
      } else if (res.code == 403 || res.code == 4003) {
        localStorage.setItem('islogin', '');
        location.href = './login';
      } else {
        if (res.code == 1000) {
          return Promise.reject(res.data);
        } else if (res.code == 1005) {
          // 升级高级会员
          messagebox.vip({
            title: lang['action_limit'],
            message: res.data,
            confirmBtnText: lang['get_senior_member'],
            confirm: (val) => {
              let url =
                lang.lang_type == 'cn'
                  ? 'https://www.elfinbook.com/senior_member'
                  : 'https://www.elfinbook.com/en/senior_member';
              window._report(`点击开通会员`, opt.limit_action || res.data);
              window.open(url);
            }
          });
        } else {
          return Promise.reject(lang['request_timeout']);
        }
      }
    })
    .catch((err) => {
      if (canShowError) {
        Message({
          message:
            typeof err == 'string' && err ? err : lang['request_timeout'],
          type: 'error'
        });
        canShowError = false;
        let timer = setTimeout(() => {
          canShowError = true;
          clearTimeout(timer);
          timer = null;
        }, 1000);
      }
      throw err;
    });
};

export { Ajax, handler1 };
